import React, { useState } from "react";
import Slider from "@material-ui/core/Slider";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components";

import {
  Time,
  formatTime,
  secondsToTime,
  timeToSeconds
} from "../../pace-fns/pace-fns";

type Props = {
  onSelectionFinish: (time: Time) => void;
  time: Time;
};

const StyledSlider = styled(Slider)`
  && {
    color: #00301b;
    
  }
`;

export const TimeSlider = ({ time, onSelectionFinish }: Props) => {
  const [currentTime, setCurrentTime] = useState(time);

  const onChange = (event: any, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      setCurrentTime(secondsToTime(newValue));
    } else {
      throw Error("Invalid time from slider");
    }
  };
  const commitChange = (event: any, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      const newTime = secondsToTime(newValue);
      setCurrentTime(newTime);
      onSelectionFinish(newTime);
    } else {
      throw Error("Invalid time from slider");
    }
  };

  const getMinTimeInSeconds = () => {
    if (time.hours < 1 && time.minutes < 1) {
      return 0;
    }
    const additionalSecondsPerIncrement = 30;
    const currentTimeInSeconds = timeToSeconds(time);
    const incrementalUnits =
      time.hours > 0 ? time.hours * 60 + time.minutes : time.minutes;

    return (
      currentTimeInSeconds - additionalSecondsPerIncrement * incrementalUnits
    );
  };

  const getMaxTimeInSeconds = () => {
    const additionalSecondsPerIncrement = 30;
    const currentTimeInSeconds = timeToSeconds(time);
    // if we are dealing in the seconds we need an upper limit
    const incrementalUnits =
      time.hours > 0
        ? time.hours * 60 + time.minutes
        : time.minutes > 0
        ? time.minutes
        : 1;
    return (
      currentTimeInSeconds + additionalSecondsPerIncrement * incrementalUnits
    );
  };

  const formatSliderLabel = (seconds: number) =>
    formatTime(secondsToTime(seconds));
  return (
    <StyledSlider
      value={timeToSeconds(currentTime)}
      valueLabelDisplay="auto"
      aria-label="time-slider"
      step={1}
      min={getMinTimeInSeconds()}
      max={getMaxTimeInSeconds()}
      getAriaValueText={formatSliderLabel}
      valueLabelFormat={formatSliderLabel}
      onChange={onChange}
      onChangeCommitted={commitChange}
      ValueLabelComponent={ValueLabelComponent}
    />
  );
};

type ValueLabelProps = {
  children: React.ReactElement;
  open: boolean;
  value: number;
};

const ValueLabelComponent = (props: ValueLabelProps) => {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
};
